import { render } from "./Marquee.vue?vue&type=template&id=5c8031a0&scoped=true"
const script = {}

import "./Marquee.vue?vue&type=style&index=0&id=5c8031a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8031a0"]])

export default __exports__